import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { AuthenticationService, UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { CartModel } from './../../../models';
import { StepIndicatorService, PageLoaderComponent, PageLoaderService } from 'lib/ng2-sapmp/src/ui-components';
import { ReviewOrderService } from './shared/providers/review-order.service';
import { ANALYTICS_CONSTANTS } from 'config';
import { HeaderService } from './../../header/header.service';
import {
  ConfirmOrderModel, BtmPaymentMethodModel, PaymentDetailsModel, LineItemsModel, OrderSourceModel,
  RequestLineItemModel, RequestCheckoutModel
} from './shared';

declare var logoutCurrentUser: any;
declare var checkCart: any;

declare var ENV_PORTAL;
const ENV_PORTAL_DOMAIN = (ENV_PORTAL === 'fnabc') ? 'FN' : 'ABC';

@Component({
  selector: 'app-review-order',
  providers: [ReviewOrderService],
  templateUrl: './review-order.component.html',
  styleUrls: ['./../checkout.component.scss']

})
export class ReviewOrderComponent implements OnInit {
  cart: CartModel = null;
  user: UserProfileModel;
  subscriberNumber: string;
  order: any;
  errorMsg = '';
  cancelCheckout: boolean;
  cancelMessage = 'Do you want to cancel the checkout?';
  routeStatus: boolean;
  prodConfig: any[];
  orderConfirmationNumber: string;
  billNumber: string;
  confirmRequest: Array<any>;
  confirmOrderModal: ConfirmOrderModel;
  btmPaymentMethodModel: BtmPaymentMethodModel;
  paymentDetailsModel: PaymentDetailsModel;
  orderSourceModel: OrderSourceModel;
  lineItemsModel: LineItemsModel;
  csrPermissionSubmitButton: boolean;
  tnctitle: string;
  tncUrl: string;
  requestLineItem: RequestLineItemModel;
  requestCheckout: RequestCheckoutModel;
  isCheckoutValid: boolean;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private stepindicatorService: StepIndicatorService,
    private revieworderservice: ReviewOrderService,
    private authenticationService: AuthenticationService,
    private utilityService: UtilityService,
    private pageLoaderService: PageLoaderService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private headerService: HeaderService
  ) {
    this.subscriberNumber = '';
    //  this.cart = new CartModel();
    this.confirmRequest = new Array<any>();
    this.confirmOrderModal = new ConfirmOrderModel();
    this.btmPaymentMethodModel = new BtmPaymentMethodModel();
    this.paymentDetailsModel = new PaymentDetailsModel();
    this.orderSourceModel = new OrderSourceModel();
    this.lineItemsModel = new LineItemsModel();
    this.confirmOrderModal.lineItems = new Array<LineItemsModel>();
    this.csrPermissionSubmitButton =
      this.utilityService.checkFieldPermission('reviewOrder.submit', JSON.parse(sessionStorage.getItem('permissions')).perm);
    this.tnctitle = undefined;
    this.tncUrl = undefined;
    this.requestCheckout = new RequestCheckoutModel();
    this.requestCheckout.lineItems = [];
    this.isCheckoutValid = true;
  }

  ngOnInit() {

    if (sessionStorage.getItem('cart') === null) {
      this.router.navigate(['/home']);
      return;
    }
    this.pageLoaderService.setPageLoaderStatus(false);
    if (ENV_PORTAL_DOMAIN === 'FN') {
      this.tnctitle = 'FirstNet Apps & Solutions ';
    } else {
      this.tnctitle = 'AT&T Business Console';
    }
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    this.routeStatus = false;
    this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
    this.stepindicatorService.setVisibility(true);
    this.cart = JSON.parse(sessionStorage.getItem('cart'));
    this.billNumber = this.utilityService.formatTelephoneNumber(this.cart.ctn);
    this.revieworderservice.createPageLoadProperties(this.cart, this.router.routerState.snapshot.url,
      'Checkout Step3 review order', 'BC Checkout Step 3 Review Order Pg');
    this.user = this.authenticationService.getUser();
    this.getProdTnc();

    if (this.cart && this.cart != null && this.cart.lineItems) {
      let index = 0;
      this.cart.lineItems.forEach((lineItem) => {
        this.requestLineItem = this.revieworderservice.createRequestCheckout(lineItem);
        this.requestCheckout.lineItems.push(this.requestLineItem);
        index++;
      });
      this.requestCheckout.fan = this.cart.fan;
      this.pageLoaderService.setPageLoaderStatus(false);
      this.revieworderservice.updateQuantityPrice(this.requestCheckout).subscribe(orderResponse => {
        this.cart = this.revieworderservice.updateCartPrice(this.cart, orderResponse);
        this.pageLoaderService.setPageLoaderStatus(true);
      }, error => {
        this.pageLoaderService.setPageLoaderStatus(true);
        this.handleError(error);
      });
    } else {
      this.pageLoaderService.setPageLoaderStatus(true);
    }

  }

  prevStep() {
    this.router.navigate(['/checkout/serviceConfiguration']);
  }

  homepage() {
    this.router.navigate(['home']);
  }

  continueshopping() {
    this.router.navigate(['browse']);
  }

  cancel() {
    this.cancelCheckout = true;
  }

  handleCancel(isCancel) {
    if (isCancel) {
      this.cart = JSON.parse(sessionStorage.getItem('cart'));
      this.user = this.authenticationService.getUser();
      if (this.cart && this.cart.lineItems && this.cart.lineItems.length > 0) {
        this.cart.lineItems[0].productConfigurations[0].value = '';
        this.cart.lineItems[0].productConfigurations[1].value = '';
        this.cart.lineItems[0].productConfigurations[2].value = '';
        if (this.cart.paymentDetails && this.cart.paymentDetails.btmPaymentMethod) {
          this.cart.paymentDetails.btmPaymentMethod.billingCTN = undefined;
        }
      }
      sessionStorage.setItem('cart', JSON.stringify(this.cart));
      this.stepindicatorService.removeStep('checkout');
      this.router.navigate(['cart']);
    }
    this.cancelCheckout = false;
  }

  placeorder() {
    this.createConfirmRequestBody(this.cart);
    this.revieworderservice.createAdobeEventProperties(this.cart, 'SUCCESS', 'formSubmit',
      ANALYTICS_CONSTANTS.EVENT_NAME_REVIEW_ORDER_SUBMIT, undefined);
    this.pageLoaderService.setPageLoaderStatus(false);
    this.revieworderservice.confirmOrder(this.confirmOrderModal)
      .subscribe( (respobj: HttpResponse<any>) => {
        this.orderConfirmationNumber = respobj.body.customerOrderNumber;
        this.billNumber = this.cart.ctn;
        this.routeStatus = true;
        this.stepindicatorService.setVisibility(false);
        this.revieworderservice.createAdobeEventProperties(this.cart, 'SUCCESS', 'formResponse',
          ANALYTICS_CONSTANTS.EVENT_NAME_REVIEW_ORDER_SUBMIT, undefined);
        this.revieworderservice.createAdobeEventProperties(this.cart, 'SUCCESS', 'formResponse',
          ANALYTICS_CONSTANTS.EVENT_CODE_ORDER_CONFIRMED, this.orderConfirmationNumber);
        this.cart.orderId = this.orderConfirmationNumber;
        this.cart.productTnc = this.tncUrl;
        sessionStorage.setItem('cart-order', JSON.stringify(this.cart));
        sessionStorage.removeItem('cart');
        // this.headerService.checkCart();
        this.router.navigate(['/checkout/confirmOrder']);
        this.pageLoaderService.setPageLoaderStatus(true);
      }, error => {
        this.pageLoaderService.setPageLoaderStatus(true);
        this.handleError(error);
      });
  }

  createConfirmRequestBody(cart) {

    this.btmPaymentMethodModel.ban = cart.ban;
    this.btmPaymentMethodModel.fan = cart.fan;
    this.btmPaymentMethodModel.billingCTN = cart.ctn;
    this.paymentDetailsModel.btmPaymentMethod = this.btmPaymentMethodModel;
    this.confirmOrderModal.paymentDetails = this.paymentDetailsModel;
    for (let obj of cart.lineItems) {
      let requestArray = new Array<any>();
      let reqObj = {};
      let flag = 0;
      this.lineItemsModel = new LineItemsModel();
      this.lineItemsModel.productId = obj.productId;
      this.lineItemsModel.quantity = obj.quantity;
      this.lineItemsModel.dcmCode = obj.sku.id;
      this.lineItemsModel.email = this.user.emailAddress;
      this.lineItemsModel.bundleSkuId = obj.sku.id;
      this.lineItemsModel.socCode = obj.sku.socCode;
      for (let item of obj.productConfigurations) {
        if (item.label === 'Terms & Conditions') {
          flag = 1;
        }
        if (item.isDropDown) {
          reqObj[item.name] = item.value.value;
        } else {
          reqObj[item.name] = item.value;
        }
      }
      if (flag === 1) {
        this.lineItemsModel.isTncAccepted = true;
      } else {
        this.lineItemsModel.isTncAccepted = false;
      }
      this.lineItemsModel.childDcmCodes = obj.childDcmCodes;
      this.lineItemsModel.configurations = [];
      this.lineItemsModel.configurations = obj.orderConfigurations;
      this.confirmOrderModal.lineItems.push(this.lineItemsModel);
    }
    this.orderSourceModel.clientIP = '343.22.22.11';
    this.orderSourceModel.clientType = 'DESKTOP';
    this.confirmOrderModal.ordersource = this.orderSourceModel;
  }

  handleError(error) {
    let isSystemError = false;
    if (error) {
      if (error.status === 401) {
        this.errorMsg = 'Session expired.Please login again.';
        isSystemError = true;
        logoutCurrentUser(true);
      } else if (error.status === 500) {
        try {
          let responseError = error.error[0];
          let errorMsg = '';
          if (responseError && responseError.errors && responseError.errors.length > 0) {
            responseError.errors.forEach(element => {
              this.cart.lineItems.forEach(lineitem => {
                let errorDesc: string = element.errorDescription;
                if (errorDesc.match(lineitem.skuId)) {
                  errorMsg += errorMsg === '' ? lineitem.displayName + '(' + lineitem.sku.skuType + ')' :
                    ', ' + lineitem.displayName + '(' + lineitem.sku.skuType + ')';
                }
              });
            });
          }
          if (errorMsg) {
            this.errorMsg = 'Your company already owns ' + errorMsg + '. Remove ' + errorMsg +
              ' from your cart and then continue checking out.';
            this.revieworderservice.createAdobeEventProperties(this.cart, 'FAILURE', 'formResponse',
              ANALYTICS_CONSTANTS.EVENT_NAME_REVIEW_ORDER_SUBMIT, undefined, error.status, error.statusText, 'Failure_BusinessRule');
            this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse', 'Failure_BusinessRule');
            isSystemError = false;
          } else {
            this.errorMsg = 'We couldn\'t complete your request. Please try again later.';
            isSystemError = true;
          }
        } catch (exception) {
          console.log(exception);
          this.errorMsg = 'We couldn\'t complete your request. Please try again later.';
          isSystemError = true;
        }
      } else {
        this.errorMsg = 'We couldn\'t complete your request. Please try again later.';
        isSystemError = true;
      }
    } else {
      throw error;
    }
    if (isSystemError) {
      this.revieworderservice.createAdobeEventProperties(this.cart, 'FAILURE', 'formResponse',
        ANALYTICS_CONSTANTS.EVENT_NAME_REVIEW_ORDER_SUBMIT, undefined, error.status, error.statusText, 'Failure_System');
      this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
    }
    this.utilityService.loadFocusOnTop();
    this.isCheckoutValid = false;
  }



  // To set Tnc url
  getProdTnc() {
    this.pageLoaderService.setPageLoaderStatus(false);
    this.revieworderservice.getServiceProdTnc().subscribe(
      (data) => {
        this.tncUrl = data[0].url;
      },
      (responseError) => {
        this.pageLoaderService.setPageLoaderStatus(true);
        this.handleError(responseError);
      }
    );
  }

}

